export default __webpack_public_path__ + "static/media/Capitolo 4.7a69e697.mp3";